/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { CardProps, Card } from '@mui/material';

export const PageContentCard: React.FC<CardProps & { disablePadding?: boolean }> = ({
  disablePadding,
  children,
  ...props
}) => (
  <Card
    {...props}
    sx={{
      p: disablePadding ? '0px' : '24px',
      borderRadius: '8px',
      width: '100%',
      height: 'fit-content',
      ...props?.sx,
    }}
    elevation={0}
  >
    {children}
  </Card>
);
